module.exports = {
  title: 'Fluid Slider with React Native Skia 🌊',
  author: 'Enzo Manuel Mangano',
  date: '2023-05-26',
  slug: 'fluid-slider',
  tags: ['skia', 'gesture-handler'],
};
